import { useState, useEffect } from 'react';

// Components
import Checkbox from '@mui/material/Checkbox';
import Alert from '../Alert';
import AlertConfirm from '../AlertConfirm';
import CircularProgress from '@mui/material/CircularProgress';

// Queries
import getGlobal from '../Queries/getGlobal';
import postGlobal from '../Queries/postGlobal';

// Styles
import styles from './index.module.sass';

export default function ValidadorDomicilio({ setSectionName, setOptionSelected }) {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [alertText, setAlertText] = useState('');
  const [isOpenConfirm, setIsOpenConfirm] = useState(false);
  const [notVerifiedChecked, setNotVerifiedChecked] = useState(false);
  const [message, setmessage] = useState('');
  const [kitBuscar, setkitBuscar] = useState('');
  const [form, setform] = useState({
    calle: '',
    ciudad: '',
    estado: '',
    cp: '',
  });

  useEffect(() => {
    setSectionName('Validador de Domicilios');
    setOptionSelected('validador');
  }, [setSectionName, setOptionSelected]);

  const handleChange = (e) => {
    setkitBuscar(e.target.value);
  };

  async function getDireccion(e) {
    if (e.key === 'Enter') {
      if (kitBuscar.length < 1) {
        setAlertText('Escribe un número de kit valido');
        setOpen(true);
        return;
      }

      setLoading(true);
      const direccionRespuesta = await getGlobal({
        tmbservice: 'omitirValidacionDomicilio',
        jsonBody: {
          noKit: kitBuscar,
        },
      });

      const { dataConsultoriaBillingAddress, omitirValidacionDomicilio } = direccionRespuesta;

      if (dataConsultoriaBillingAddress.typeMessage !== 'error') {
        setNotVerifiedChecked(omitirValidacionDomicilio);
        setform({
          calle: `${dataConsultoriaBillingAddress.line1} ${dataConsultoriaBillingAddress.line2} ${dataConsultoriaBillingAddress.line3}`,
          ciudad: dataConsultoriaBillingAddress.ciudad,
          estado: dataConsultoriaBillingAddress.estado,
          cp: dataConsultoriaBillingAddress.CP,
        });
      } else {
        setAlertText('No se obtuvieron datos del kit solicitado');
        setform({
          calle: '-----',
          ciudad: '-----',
          estado: '-----',
          cp: '00000',
        });
        setNotVerifiedChecked(false);
        setOpen(true);
      }

      setLoading(false);
    }
  }

  async function verifyAddress() {
    setLoading(true);
    setIsOpenConfirm(false);
    const respuesta = await postGlobal({
      tmbservice: 'omitirValidacionDomicilio',
      jsonBody: {
        omitirValidacionDomicilio: notVerifiedChecked,
        noKit: kitBuscar,
      },
    });

    const { messageCode, message } = respuesta;

    if (messageCode === 200) {
      setAlertText('Se ha actualizado la validación de la dirección seleccionada');
    } else {
      setAlertText(message);
    }
    setOpen(true);
    setLoading(false);
  }

  function openAlertConfirm() {
    if (!notVerifiedChecked) {
      setNotVerifiedChecked(true);
      setmessage('omitir');
    } else {
      setNotVerifiedChecked(false);
      setmessage('activar');
    }
    setIsOpenConfirm(true);
  }

  return (
    <div className={`${styles.personal}`}>
      <Alert open={open} setOpen={setOpen} title='Terramar' text={alertText} />
      <AlertConfirm
        isOpen={isOpenConfirm}
        callback={() => verifyAddress()}
        setIsOpen={setIsOpenConfirm}
        titleAlert={`¿Deseas ${message} la validación de la dirección?`}
        customComponent=''
        btnDanger='Cancelar'
        btnPrimary='Aceptar'
        notVerifiedChecked={notVerifiedChecked}
        setNotVerifiedChecked={setNotVerifiedChecked}
      />

      <div className={styles.areaName}>
        <i className={`material-icons-outlined ${styles.titleIcon}`}>person_search</i>
        Número de kit
      </div>

      <div className={styles.areaContainer}>
        <div className={`${styles.inputContainer} ${styles.width100}`}>
          <input
            type='number'
            placeholder='¿Qué kit quieres buscar?'
            className={styles.inputText}
            onChange={handleChange}
            name='kit'
            maxLength='10'
            value={kitBuscar || ''}
            required
            onKeyDown={(e) => getDireccion(e)}
            autoComplete='off'
          />
        </div>
      </div>

      {!loading ? (
        <div>
          <div className={styles.areaName}>
            <i className={`material-icons-outlined ${styles.titleIcon}`}>home</i>
            Dirección registrada
          </div>
          <div className={styles.areaContainer}>
            <div className={`${styles.inputContainer} ${styles.width100}`}>
              <span className={styles.titleSpan}>Dirección:</span>{' '}
              <span className={styles.span}>{form.calle || '-----'}</span>
            </div>

            <div className={`${styles.inputContainer} ${styles.width33}`}>
              <span className={styles.titleSpan}>Ciudad:</span>{' '}
              <span className={styles.span}>{form.ciudad || '-----'}</span>
            </div>

            <div className={`${styles.inputContainer} ${styles.width33}`}>
              <span className={styles.titleSpan}>Estado: </span>{' '}
              <span className={styles.span}>{form.estado || '-----'}</span>
            </div>

            <div className={`${styles.inputContainer} ${styles.width33}`}>
              <span className={styles.titleSpan}>CP:</span>{' '}
              <span className={styles.span}>{form.cp || '00000'}</span>
            </div>
            <div className={styles.areaName}>
              <Checkbox
                checked={notVerifiedChecked}
                onClick={() => {
                  openAlertConfirm();
                }}
              />
              <span className={styles.titleSpan}>Omitir la validación de domicilio</span>
            </div>
          </div>
        </div>
      ) : (
        <div className={styles.cargando}>
          <CircularProgress />
        </div>
      )}
    </div>
  );
}
